import React, { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import InvoiceItems from "./InvoiceItems";
import { FaFilePdf } from "react-icons/fa6";
import { ConvertPriceToString } from "../../../Helpers/CustomConverter";
import { useInvoices } from "../../../Providers/InvoicesProvider";
import useDownloadFinanceDocuments from "../../../Hooks/useDownloadFinanceDocuments";
import LoadingSpinner from "../../Components/LoadingSpinner";
import { formatDocumentNumber } from "../../../Helpers/DocumNumHelper";
import { useAuth } from "../../../Providers/AuthProvider";

const Invoice = ({ invoice, setShowNoEInvoiceModal }) => {
  const { authState } = useAuth()
  const [ordersValue, setOrdersValue] = useState(0);
  const { handleGetArchiveInvoiceItems } = useInvoices();
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [showItems, setShowItems] = useState(false);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const { downloadFinanceDocument, isLoading } = useDownloadFinanceDocuments();
  function reverseDate(date) {
    const [year, month, day] = date.split('-')
    return `${day}-${month}-${year}`
  }

  useEffect(() => {
    if (showItems) {
      handleGetItems()
    }
  }, [showItems])

  const handleGetItems = async () => {
    setIsLoadingItems(true)
    const items = await handleGetArchiveInvoiceItems(invoice)
    setInvoiceItems(items)
    setIsLoadingItems(false)
  }

  const handleDownloadPdf = () => {
    if ((authState.user && authState.user.customerInfo && authState.user.customerInfo[0].isEInvoiceConsent) || (authState.user && authState.user.isOperator)) {
      downloadFinanceDocument(invoice.nrDoc, invoice.docDate, invoice.oddzial)
      return
    }
    else {
      setShowNoEInvoiceModal(true)
    }
  }

  return (
    <>
      <tr className="hoverable-row">
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{invoice.seller}</td>
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{formatDocumentNumber(invoice.nrDoc, invoice.docDate, invoice.oddzial)}</td>
        <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
          {reverseDate(invoice.docDate.substring(0, invoice.docDate.indexOf("T")))}
        </td>
        <td style={{ alignContent: "center", textAlign: "left", fontSize: '14px', textAlign: 'right' }} onClick={() => setShowItems(!showItems)}>
          {ConvertPriceToString(invoice.value, null)}
        </td>
        <td style={{ alignContent: "center", textAlign: 'left', fontSize: '14px', textAlign: 'right' }} onClick={() => setShowItems(!showItems)}>
          {ConvertPriceToString(invoice.paid, null)}
        </td>
        <td style={{ fontSize: '14px', verticalAlign: 'middle' }} onClick={() => setShowItems(!showItems)}>
          {invoice.comments}
        </td>
        <td style={{ alignContent: "center", textAlign: "center" }}>
          {isLoading ? <LoadingSpinner width={2} height={2} bubble={false} /> : <FaFilePdf style={{ cursor: "pointer" }} color="black" size={20} onClick={() => handleDownloadPdf()} />}
        </td>
      </tr>
      {showItems && (
        <tr>
          <td colSpan="7" style={{ padding: 10 }}>
            <InvoiceItems items={invoiceItems} isLoading={isLoadingItems} />
          </td>
        </tr>
      )}
    </>
  );
};

export default Invoice;
